import React, { useState } from "react";
import { Box, Card, CardContent, Typography, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import {
  HasAdaptiveAssessment,
  HasAutoEvaluatedAssessment,
  hasDescriptiveAutoAssessment,
  HasTeacherEvaluatedAssessment,
} from "../../../../Utils/features";

function AssessmentTypePopUP({
  setIsAssessmentTypePopUp,
  assDefaultRouteData,
}) {
  const [selectedBox, setSelectedBox] = useState("");
  const navigate = useNavigate();

  const handleSelect = (value) => {
    setSelectedBox(value);
  };

  const handleClick = () => {
    if (selectedBox) {
      localStorage.setItem("selectedBox", selectedBox);
      navigate("/create", {
        state: {
          selectedBox: selectedBox,
          defaultRouteData: assDefaultRouteData,
        },
      });
    }
  };

  const ORANGE = "#f77f00";

  const options = [
    HasAdaptiveAssessment && {
      id: "adaptive",
      title: "Adaptive",
      points: [
        "Difficulty and skills adjust based on student performance.",
        "Personalized and efficient way to measure learning outcome.",
        "MCQ questions: Auto-evaluation.",
      ],
    },
    HasAutoEvaluatedAssessment && {
      id: "auto-evaluate",
      title: "Auto-Evaluated",
      points: hasDescriptiveAutoAssessment
        ? [
            "Same question sequence for every student.",
            "MCQ questions: Auto-evaluation.",
            "Descriptive questions: Auto-evaluation.",
          ]
        : [
            "Same question sequence for every student.",
            "MCQ questions: Auto-evaluation.",
          ],
    },
    HasTeacherEvaluatedAssessment && {
      id: "teacher-evaluate",
      title: "Teacher-Evaluated",
      points: [
        "Same question sequence for every student.",
        "MCQ & descriptive questions.",
        "Teacher evaluates answers manually.",
      ],
    },
  ].filter(Boolean);

  return (
    <Box
      className="d-flex align-items-center justify-content-center"
      sx={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.45)",
        zIndex: 9999,
        p: 2,
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          borderRadius: 3,
          width: "100%",
          maxWidth: 1000,
          p: 3,
          position: "relative",
        }}
      >
        {/* Close Button */}
        <CloseIcon
          onClick={() => setIsAssessmentTypePopUp(false)}
          sx={{
            position: "absolute",
            top: 16,
            right: 16,
            cursor: "pointer",
            color: "#777",
          }}
        />

        {/* Title */}
        <Typography
          variant="h5"
          sx={{ fontWeight: 600, mb: 3, textAlign: "center" }}
        >
          Select Assessment Type
        </Typography>

        {/* Cards */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: `repeat(${options.length}, minmax(0, 1fr))`,
            gap: 2,
            mb: 3,
          }}
        >
          {options.map((opt) => (
            <Card
              key={opt.id}
              onClick={() => handleSelect(opt.id)}
              sx={{
                cursor: "pointer",
                borderRadius: 3,
                height: "100%",
                border:
                  selectedBox === opt.id
                    ? `2px solid ${ORANGE}`
                    : "2px solid transparent",
                boxShadow: "0 8px 22px rgba(0,0,0,0.08)",
                transition: "all 0.25s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                },
              }}
            >
              <CardContent
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ color: ORANGE, fontWeight: 600, mb: 2 }}
                >
                  {opt.title}
                </Typography>

                <ul style={{ paddingLeft: 18, margin: 0 }}>
                  {opt.points.map((p, i) => (
                    <li key={i} style={{ marginBottom: 10, color: "#555" }}>
                      {p}
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </Box>

        {/* Footer Button (UNCHANGED LOGIC) */}
        <Box className="d-flex justify-content-center">
          <button
            className="add_button"
            id="add_assessmenttype_btn"
            disabled={!selectedBox}
            onClick={handleClick}
            style={{
              border: "none",
              borderRadius: "999px",
              padding: "12px 40px",
              background: selectedBox ? ORANGE : "rgb(249, 176, 98)",
              color: "#fff",
              cursor: selectedBox ? "pointer" : "not-allowed",
            }}
          >
            Next
          </button>
        </Box>
      </Box>
    </Box>
  );
}

export default AssessmentTypePopUP;
